module.exports = __webpack_public_path__ + "static/media/login-bg4.275d1d0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-bg4.jpg
// module id = 172
// module chunks = 0